import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import RenderInputField from "components/AudienceDashboard/ReusableComponents/RenderInputField/RenderInputField";
import { filterColArry, logsTableColumns } from "./data";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import { DisabledByDefaultRounded, PlayArrowRounded} from "@mui/icons-material";
import { constraintsOptions, converAttrToDatagridCol, inputTypes, selectOptKeyName } from "data/globalData";
import DatagridWithApiPagination from "components/AudienceDashboard/ReusableComponents/DatagridWithApiPagination/DatagridWithApiPagination";
import moment from "moment";
import { AudienceDashboardState } from "context/AudienceDashboardContext";
import { AuthState } from "context/AuthContext";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const FacebookAudiencePush = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();
	const { fbDrawerListItems, setFbDrawerListItems } = AudienceDashboardState();

	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [selected, setSelected] = React.useState({});

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});
	const [filterData, setFilterData] = useState({ ...defaultData });
	const [logs, setLogs] = useState([]);

	const [filterColumns, setFilterColumns] = useState(filterColArry);

	const getDropdownOptionsAPI = async () => {
		setLoadingOpen(true);
		try {
			const res = await pythonVmInstance({
				url: `/audience/facebook/filters`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "get",
			});
			// setFbDrawerListItems(res.data.result);
			setLoadingOpen(false);
			return res.data.result;
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to load DropdownItems`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const fetchDropdownOptions = async () => {
		if (fbDrawerListItems) return fbDrawerListItems;
		else {
			const result = await getDropdownOptionsAPI();
			setFbDrawerListItems(result);
			return result;
		}
	};
	const fetch = async () => {
		const result = await fetchDropdownOptions();
		setFilterColumns((allColumns) => {
			let obj = result;
			return allColumns.map((row) => {
				if (obj[row.key] && [inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key].includes(row?.input_type)) {
					let opt = row[selectOptKeyName] ? row[selectOptKeyName] : {};
					opt = { ...opt, list: obj[row.key] };
					return { ...row, [selectOptKeyName]: opt };
				} else return row;
			});
		});
	};
	useEffect(() => {
		fetch();
	}, []);
	console.log(filterColumns, "dsmfnbdsm");

	const fetchSchedules = async (limit, offset) => {
		try {
			const res = await pythonVmInstance({
				url: `audience/facebook/audiences?offset=${offset}&limit=${limit}`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "get",
			});
			return res.data.result;
		} catch (error) {
			setSnackBarOpen(true);
			// console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `Unable to fetch Audiences`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);
		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
			return;
		}

		try {
			await pythonVmInstance({
				url: `/audience/facebook/create_audience`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				data: {
					...filterData,
					email: user.email,
				},
			}).then(async (res) => {
				const { result, total_rows } = await fetchSchedules(20, 0);
				setLogs(result);

				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: res?.data.message ?? "Created Successfullyy",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};
	const handleActiveInactivButton = async (row, value) => {
		setLoadingOpen(true);

		try {
			const body = { is_active: !value };
			await pythonVmInstance({
				url: `/audience/facebook/update?id=${row.id}`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "patch",
				data: body,
			}).then(async (res) => {
				setLogs((prev) =>
					prev.map((item) => {
						if (item.id === row.id) return { ...item, ...body };
						else return item;
					})
				);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: res?.data.message ?? "Created Successfullyy",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const handleDeleteAudience = async () => {
		setLoadingOpen(true);
		let row = selected
		try {
			await pythonVmInstance({
				url: `/audience/facebook/delete?id=${row.id}`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "delete",
			}).then(async (res) => {
				setLogs((prev) =>
					prev.filter((item) => (item.id !== row.id))
				);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: res?.data.message ?? "Deleted Successfullyy",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
		handleClose()
	};

	const DeleteButton = ({row}) =>{
		return (
			<DeleteIcon onClick={() => {setSelected(row);handleClickOpen()}} /> 
		)
	}

	const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
	setSelected({})
    setOpen(false);
  };
	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* <Typography variant="h6">All Channel Dispatch</Typography> */}
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} pt={2}>
				{filterColumns?.map((col) => {
					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={selectOptKeyName}
							width={"19%"}
							longWidth={"300px"}
							disabled={false}
							// error={errObj?.[column.key] ? true : false}
							// setError={setErrorObj}
							// dependencyColData={}
							disableLabel={true}
						/>
					);
				})}

				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						sx={{ width: "150px" }}
						type="submit"
						disabled={loading}
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <></>}>
						{loading ? "Loading..." : "Create"}
					</Button>
				</Box>
			</Box>
			{/* logs */}
			<Stack width="100%" height="60vh">
				<Typography variant="h6">Audience</Typography>
				<DatagridWithApiPagination
					setTableRows={setLogs}
					tableRows={logs}
					columns={[
						...Object.values(logsTableColumns)?.map((row) => converAttrToDatagridCol(row)),
						{
							field: "created_at",
							headerName: "Created",
							align: "center",
							headerAlign: "center",
							sortable: false,
							renderCell: ({ row, field }) => {
								if (row[field]) return moment(row[field]).format("DD/MM/YYYY HH:mm");
								else return "";
							},
							flex: 1,
							minWidth: 120,
						},

						{
							field: "updated_at",
							headerName: "Last Updated",
							align: "center",
							headerAlign: "center",
							sortable: false,
							renderCell: ({ row, field }) => {
								if (row[field]) return moment(row[field]).format("DD/MM/YYYY  HH:mm");
								else return "";
							},
							flex: 1,
							minWidth: 120,
						},

						{
							field: "status",
							headerName: "Status",
							align: "center",
							headerAlign: "center",
							sortable: false,
							renderCell: ({ row, field }) => {
								if (row["message"] == "Successfully pushed") return "Success";
								else if (row["message"] == "Running...") return "Pending";
								else return "Error";
							},
							flex: 1,
							minWidth: 120,
						},
						{
							field: "message",
							headerName: "Status Remarks",
							align: "center",
							headerAlign: "center",
							sortable: false,
							renderCell: ({ row, field }) => {
								if (row[field]) return row[field];
								else return "Pending...";
							},
							flex: 1,
							minWidth: 120,
						},
						{
							headerName: "Action",
							field: "is_active",
							minWidth: 130,
							headerAlign: "center",
							align: "center",
							flex: 1,

							renderCell: ({ row, field }) => {
								if (row.frequency === "one_time") return <Stack flexDirection="row" columnGap={1} justifyContent="center" alignItems="center"><Stack width="80%">----</Stack> <DeleteButton row ={row}/></Stack>;
								if (row[field])
									return (
										<Stack flexDirection="row" columnGap={1} justifyContent="center" alignItems="center" width = '100%'>
										<Button
											onClick={(e) => handleActiveInactivButton(row, row[field])}
											variant="contained"
											size="small"
											color="warning"
											sx={{ width: "80%" }}
											startIcon={<DisabledByDefaultRounded />}>
											Stop
										</Button>
										<DeleteButton  row ={row}/>
										</Stack>
									);
								else
									return (
										<Stack flexDirection="row" columnGap={1} justifyContent="center" alignItems="center">

										<Button
											onClick={(e) => handleActiveInactivButton(row, row[field])}
											variant="contained"
											size="small"
											color="info"
											sx={{ width: "80%" }}
											startIcon={<PlayArrowRounded />}>
											Resume
										</Button>
										<DeleteButton row ={row} />

										</Stack>
									);
							},
						},
					]}
					fetchTableRows={fetchSchedules}
					recordsLimit={20}
					polling = {true}
				/>
			</Stack>
			<Stack>
				<React.Fragment>
				<Dialog
					open={open}
					// onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
					{"Delete Audience?"}
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Do you want to delete <b>"{selected?.audience_name}"</b> Audience.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button onClick={handleClose}>Cancle</Button>
					<Button onClick={handleDeleteAudience} autoFocus>
						OK
					</Button>
					</DialogActions>
				</Dialog>
				</React.Fragment>
			</Stack>
		</Stack>
	);
};

export default FacebookAudiencePush;
